import {
  PerspectivesGroupsComponentTypes,
  PerspectivesGroupsWorkspace,
} from '../types';
import { SelectOption } from '@ardoq/select';

export const toWorkspaceOption = (
  workspace: PerspectivesGroupsWorkspace,
  additionalProperties: Partial<SelectOption<string>> = {}
): SelectOption<string> => ({
  value: workspace.id,
  label: workspace.name,
  ...additionalProperties,
});

export const toComponentTypeOption = (
  componentType: PerspectivesGroupsComponentTypes
) => ({
  value: componentType.id,
  label: componentType.name,
});
